import { createRouter, createWebHistory } from 'vue-router'

// Middlewares
import authMiddleware from '@/middlewares/auth';
import guestMiddleware from '@/middlewares/guest';

// Layouts & views
import DashboardLayout from '@/layouts/dashboard/DashboardLayout'
import HomeView from '@/views/HomeView.vue'
import SettingsView from '@/views/SettingsView'

// Routes
import auth from './routes/auth'
import users from './routes/admin/users'
import customers from './routes/admin/customers'
import products from './routes/admin/products'
import categories from './routes/admin/categories'
import notifications from './routes/admin/notifications'
import tickets from './routes/admin/tickets'
import portal from './routes/portal'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'dashboard' }
  },
  {
    path: '/dashboard',
    component: DashboardLayout,
    meta: {
      middleware: ['auth']
    },
    children: [
      {
        name: 'dashboard',
        path: '',
        component: HomeView
      },
      {
        name: 'settings',
        path: 'settings',
        component: SettingsView,
        meta: { middleware: ['auth'], roles: ['admin', 'super_admin'] }
      },
      ...users,
      ...customers,
      ...products,
      ...categories,
      ...notifications,
      ...tickets,
      ...portal,
    ]
  },

  ...auth,
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(guestMiddleware);
router.beforeEach(authMiddleware);

export default router
